import { Component } from "@angular/core";

// Public, unauthenticated page (no AuthGuardService on its route in
// app-routing.module.ts, same as /signin) - hosts the Pigeon app's privacy
// policy as a stable, linkable URL for use in the App Store / Play Store
// listings. Static content converted from "Pigeon - Privacy Policy.docx";
// update this template directly if the policy text changes.
@Component({
  selector: "app-privacy-policy-public",
  templateUrl: "./privacy-policy-public.component.html",
  styleUrls: ["./privacy-policy-public.component.scss"],
})
export class PrivacyPolicyPublicComponent {}
